import { render, staticRenderFns } from "./message_list.vue?vue&type=template&id=9c339de2&scoped=true"
import script from "./message_list.vue?vue&type=script&lang=js"
export * from "./message_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c339de2",
  null
  
)

export default component.exports